import React, { useCallback } from 'react';
import { useDispatch, useSelector } from '@shared/store';
import { MBAttachmentListComponent } from '../components/attachment/list';
import * as Actions from '../store/actions';

const emptyArray = [];

interface Props {
  draftId: string;
}

export function MBAttachmentList({ draftId }: Props) {
  const dispatch = useDispatch();
  const attachments = useSelector(
    state => state.chatInput.attachmentsFromDraftId[draftId] || emptyArray,
  );
  const onRemove = useCallback(
    (attachment: MBAPI.ChatAttachment) => Actions.removeAttachment(attachment, draftId)(dispatch),
    [dispatch, draftId],
  );
  return <MBAttachmentListComponent attachments={attachments} onRemove={onRemove} />;
}
